import React, {useEffect, useState} from "react";
import {Card, Col, Image, Row, Carousel, Button, Modal, Form} from "react-bootstrap";
import {Link} from "react-router-dom";
import axios from "axios";
import pkg from '../../package.json';

const Room = () => {
    const [results, setResult] = useState([])
    const [show, setShow] = useState(false)
    const [currentRoom, setCurrentRoom] = useState()
    const [groups, setGroups] = useState([])
    const [currentGroup, setCurrentGroup] = useState(0)

    useEffect(() => {
        axios.get(pkg.api_url+'/rooms').then((res) => {
            let d = res.data
            console.log(d);
            setResult(d);
        })

        axios.get(pkg.api_url+'/groups').then((res) => {
            let d = res.data
            console.log("Groups ==========",d);
            setGroups(d);
        })
    }, [])

    return (
    <>
      <Form.Group className="mt-4">
          <Form.Label><h4><b>เลือกประเภทห้อง</b></h4></Form.Label>
          <Form.Control as="select" onChange={(e)=>{
              let value = e.target.value;
              setCurrentGroup(value);
          }}>
              <option value="0"> - ทั้งหมด - </option>
              {
                  groups.map((g) => {
                      return (
                          <option key={g.id} value={g.id}> {g.name} </option>
                      )
                  })
              }
          </Form.Control>
      </Form.Group>
      <hr/>
      <Row className="mt-2">
          {
              results.filter(room=>{
                  if(currentGroup=='0')return true;
                  if(room.group.id==currentGroup){
                      return true;
                  }else{
                      return false;
                  }
              }).map((room) => {
                  return (
                      <Col key={room.id} md="6" className="mb-4">
                          <Card>
                              <Card.Header>
                                  <h5><b>{room.name}</b></h5>
                              </Card.Header>
                              <Card.Body>
                                  <div className='fix_height mb-3'>
                                      <Carousel>
                                          {room.imgs.map((img) => {
                                              return (
                                                  <Carousel.Item>
                                                      <img className="d-block w-100" src={'/booking/strapi'+img.url}/>
                                                  </Carousel.Item>
                                              )
                                          })}
                                      </Carousel>
                                  </div>
                                  <div>จำนวนที่นั่ง : {room.seat} คน</div>
                                  <div>สถานที่ตั้ง : {room.location}</div>
                              </Card.Body>
                              <Card.Footer>
                                  <div className="text-right">
                                      <Button className="mr-3" variant="secondary" onClick={() => {
                                          setCurrentRoom(room)
                                          setShow(true)
                                      }}>รายละเอียดเพิ่มเติม</Button>
                                      <Link to={"booking/" + room.id} className="btn btn-primary">เลือกห้อง</Link>
                                  </div>
                              </Card.Footer>
                          </Card>
                      </Col>
                  )
              })
          }
          <Modal size="" show={show} onHide={() => {
              setShow(false)
          }}>
              <Modal.Header>
                  <Modal.Title>
                      <h5><b>อุปกรณ์ภายใน{currentRoom && currentRoom.name}</b></h5>
                  </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  <div dangerouslySetInnerHTML={{__html: currentRoom && currentRoom.detail}}></div>
              </Modal.Body>
              <Modal.Footer>
                  <Button variant="secondary" onClick={() => {
                      setShow(false)
                  }}>
                      ปิด
                  </Button>
              </Modal.Footer>
          </Modal>
      </Row>
    </>
    )
}
export default Room;